import { useState, useEffect, useContext } from "react";
import { getobj, dltobj, postobj, updateobj } from "../../apicall/apicall";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, Switch } from "@mui/material";
import { boxStyle } from "../../style/style";
import Pagination from "@mui/material/Pagination";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  StyledTableCell,
  StyledTableRow,
  buttonPosition,
  buttonStyle3,
  crossHubAction,
} from "../../style/style";
import { Button } from "@mui/material";
import "react-notifications/lib/notifications.css";
import HubDevices from "./CustomerHubdevices";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { loginContext } from "../../context/contexts";
import { timeStamp } from "../../apicall/commonFunction";
import { TextField, MenuItem } from "@mui/material";
import { useLocation } from "react-router-dom";
import HubHistoryTrail from "../HubHistoryTrail";
import CloseIcon from "@mui/icons-material/Close";

export default function CustomerHubs(props) {
  const [hubs, sethubs] = useState();
  const [page, setpage] = useState(1);
  const [totalpage, setpaget] = useState();
  const [open, setopen] = useState(false);
  const [opencomment, setopencomment] = useState(false);
  const [hub, sethub] = useState({
    hub_id: "",
    customer_id: props.id,
    active_status: false,
    comments: "",
    free_period: 0,
  });
  const [refresh, setrefresh] = useState(false);
  const context = useContext(loginContext);
  const loc = useLocation();
  const [hub_d, sethub_d] = useState(
    sessionStorage.getItem("value") === "5" &&
      sessionStorage.getItem("hub_d") === "true"
      ? true
      : false,
  );
  const [loaded, setloaded] = useState(true);
  const [comments, setcomments] = useState();
  const [hubTrail, sethubTrail] = useState({ id: "", value: false });
  const [error, setError] = useState({});
  const [freePeriodType, setFreePeriodType] = useState([]);
  const reset = { active_status: false };
  const isAdmin = localStorage.getItem("role") === "ADMIN";
  console.log(props);
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    if (type === "checkbox" && name === "active_status") {
      sethub({
        ...hub,
        active_status: checked,
      });
    } else if (name === "free_period") {
      sethub({ ...hub, free_period: e.target.value });
    } else {
      sethub({
        ...hub,
        [name]: value,
        customer_id: props.id,
      });
    }
  };
  const validateForm = (data) => {
    let newErr = {};
    if (!data.hub_id.trim()) {
      newErr.hub_id = "First Name cannot be blank";
    }
    if (data.hub_id.trim().length > 50) {
      newErr.hub_id = "Max lenngth exceeded(50)";
    }

    if (Object.keys(newErr).length > 0) {
      setError(newErr);
      return false;
    }
    return true;
  };

  const updatecomment = (comments) => {
    console.log(comments);
    const url =
      process.env.REACT_APP_ZEWA_URL + "hub/comment/" + comments["id"] + "/";
    const res = updateobj(
      url,
      comments["comments"] === "{}" ? "" : comments["comments"],
    );
    res.then(function (res) {
      //console.log(res);
      setopencomment(false);
      setrefresh(!refresh);
      setcomments("");
    });
  };

  const handlePagechange = (event, value) => {
    setloaded(true);
    setpage(value);
    const url =
      process.env.REACT_APP_ZEWA_URL + "hub/" + props.id + "/?page=" + value;
    const d = getobj(url);
    d.then(function (res) {
      sethubs(res.results);
      setloaded(false);
    });
  };
  const addhub = () => {
    console.log(hub);

    if (!hub["hub_id"] || !validateForm(hub)) {
      NotificationManager.remove(NotificationManager.listNotify[0]);
      NotificationManager.error("Please Enter Hub Id");
      return;
    }

    const url = `${process.env.REACT_APP_ZEWA_URL}hub/${props.id}/`;

    postobj(url, hub)
      .then((response) => {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        if (response.status === 200) {
          sethub(reset);
          setrefresh(!refresh);
          setopen(false);
          NotificationManager.success(response.Message);
        } else {
          NotificationManager.error(response.Message, "Failed", 2000);
        }
      })
      .catch((err) => {
        NotificationManager.remove(NotificationManager.listNotify[0]);
        NotificationManager.error(
          err?.Message || "Something went wrong",
          "Failed",
          2000,
        );
      });
  };

  const handleClick = (id) => {
    sethub_d(true);
  };
  const handleaction = (id, val, hub_id) => {
    //console.log(id, val);

    if (val === "Detail") {
      context.sethub(id);
      handleClick(id);
      props.sethub_id(hub_id);
    } else if (val === "Delete") {
      handleDelete(id);
    } else if (val === "Update Comment") {
      setcomments({
        ...comments,
        id: id,
        comments: "",
      });
      setopencomment(true);
    } else if (val === "action") {
      sethubTrail({
        id: id,
        value: true,
      });
    } else {
      const url = process.env.REACT_APP_ZEWA_URL + "hub/0/";
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = {
        id: id,
        customer_id: sessionStorage.getItem("customer_id"),
        active_status: status,
      };
      updateobj(url, data)
        .then((response) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          if (response.status === 200) {
            NotificationManager.success(response.Message, "Updated", 2000);
            setrefresh((prev) => !prev);
            setpage(1);
          } else {
            NotificationManager.error(response.Message, "Failed", 2000);
          }
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error(
            err?.Message || "Something went wrong",
            "Failed",
            2000,
          );
        });
      // console.log(data);
    }
  };
  useEffect(() => {
    let url = process.env.REACT_APP_ZEWA_URL + "device/free-period-types/";
    const d = getobj(url);
    d.then(function (res) {
      setFreePeriodType(res);
    });
  }, []);

  useEffect(() => {
    let url;
    if (props.search === "") {
      url = process.env.REACT_APP_ZEWA_URL + "hub/" + props.id + "/";
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "hub/" +
        props.id +
        "/?search=" +
        props.search;
    }
    const res = getobj(url);
    res.then(function (r) {
      // console.log(r["Message"]);
      if (r["Message"] === "No hub added yet") {
        sethubs(false);
        setloaded(false);
      } else {
        if (r.count % 5 > 0) {
          setpaget(Math.floor(r.count / 5) + 1);
        } else {
          setpaget(Math.floor(r.count / 5));
        }
        sethubs(r.results);
        setloaded(false);
      }
    });
  }, [refresh, props.search, props.id]);
  const handleDelete = (id) => {
    const url = process.env.REACT_APP_ZEWA_URL + "hub/0/";
    const res = dltobj(url, { id: id });
    res.then(function (res) {
      if (res["Message"] === "Hub deleted successfully") {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Hub Deleted.", "Deleted", 2000);
        setrefresh((prev) => !prev);
      } else if (
        res["Messgae"] === "You do not have access to delete the hub"
      ) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "You do not have access to delete the hub",
          "Failed",
          2000,
        );
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "Could not delete as it is associated with device",
          "Failed",
          2000,
        );
      }
    });
  };
  return (
    <div style={{ margin: "10px", padding: "5px" }}>
      {!hub_d ? (
        <div>
          <Box sx={buttonPosition}>
            <Button
              sx={buttonPosition}
              variant="contained"
              color="primary"
              onClick={() => {
                setopen(true);
              }}
            >
              add hub
            </Button>
          </Box>
          <Box sx={boxStyle}>
            {loaded ? (
              <img
                src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
                alt="logo"
              />
            ) : hubs ? (
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        <b>Hub Id</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Last Active</b>
                      </StyledTableCell>
                      {/* <StyledTableCell>
                        <b>Organisation Name</b>
                      </StyledTableCell> */}
                      <StyledTableCell>
                        <b>Status</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Free Period</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Comments</b>
                      </StyledTableCell>

                      <StyledTableCell></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {hubs &&
                      hubs.map((hub) => (
                        <StyledTableRow key={hub.id}>
                          <StyledTableCell>{hub.hub_id}</StyledTableCell>
                          <StyledTableCell>
                            {hub.last_active === "NA"
                              ? "No Data"
                              : timeStamp(hub.last_active)}
                          </StyledTableCell>
                          {/* <StyledTableCell>{hub.org_name}</StyledTableCell> */}
                          <StyledTableCell>
                            {hub.active_status ? "Active" : "Inactive"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {hub.free_period_detail &&
                            hub.free_period_detail.free_time_period !== ""
                              ? hub.free_period_detail.free_time_period
                              : "0"}{" "}
                            months
                          </StyledTableCell>
                          <StyledTableCell>{hub.comments}</StyledTableCell>

                          <StyledTableCell>
                            <Button>
                              <TextField
                                select
                                name="device_name"
                                id="deviceName"
                                sx={{ width: "clamp(80px, 12vw, 100px)" }}
                                variant="outlined"
                                label="Action"
                                //value={actValue}
                                onChange={(e) => {
                                  handleaction(
                                    hub.id,
                                    e.target.value,
                                    hub.hub_id,
                                  );
                                }}
                              >
                                <MenuItem value="Detail">Devices</MenuItem>
                                <MenuItem
                                  value={
                                    hub.active_status
                                      ? "Deactivate"
                                      : "Activate"
                                  }
                                >
                                  {hub.active_status
                                    ? "Deactivate"
                                    : "Activate"}
                                </MenuItem>
                                <MenuItem value="Update Comment">
                                  Update Comment
                                </MenuItem>

                                {loc.pathname === "/admin" && (
                                  <MenuItem value="Delete">Delete</MenuItem>
                                )}
                                <MenuItem value="action">Actions</MenuItem>
                              </TextField>
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              "No Hubs added yet."
            )}
            <NotificationContainer />
            <Pagination
              count={totalpage}
              page={page}
              variant="outlined"
              color="primary"
              onChange={handlePagechange}
            />
            <Dialog
              open={open}
              onClose={() => {
                setopen(false);
              }}
              sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
              maxWidth="xs"
            >
              <DialogTitle
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <h3>Add Hub</h3>
                <Box>
                  Active Status:{" "}
                  <Switch
                    checked={hub.active_status}
                    onChange={handleChange}
                    name="active_status"
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Box>
              </DialogTitle>

              <DialogContent>
                <TextField
                  id="hub_id"
                  label="Enter Hub Id"
                  name="hub_id"
                  helperText={error.hub_id ? error.hub_id : ""}
                  error={error.hub_id || false}
                  type="text"
                  variant="outlined"
                  sx={{ margin: "5px", width: "80%" }}
                  onChange={handleChange}
                />
                <br />

                <TextField
                  id="hub_id"
                  name="comments"
                  label="Enter Comment"
                  type="text"
                  variant="outlined"
                  sx={{ margin: "5px", width: "80%" }}
                  onChange={handleChange}
                />
                <br />
                <Box>
                  {isAdmin && (
                    <TextField
                      id="outlined-select"
                      select
                      label="Select Free Period"
                      sx={{ margin: "5px", width: "80%" }}
                      name="free_period"
                      onChange={handleChange}
                      required
                    >
                      {freePeriodType.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.free_time_period} month
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  color="primary"
                  sx={buttonStyle3}
                  onClick={() => {
                    addhub(hub);
                  }}
                >
                  Add
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  sx={buttonStyle3}
                  onClick={() => {
                    setopen(false);
                  }}
                >
                  cancel
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={opencomment} onClose={() => setopencomment(false)}>
              <DialogTitle>Add Comments</DialogTitle>

              <TextField
                label="Add Comments"
                name="comments"
                id="deviceName"
                sx={{ width: "100%", maxWidth: "400px", margin: "0.3125rem" }}
                variant="outlined"
                // value={test_device}
                onChange={(e) => {
                  setcomments({
                    ...comments,
                    comments: e.target.value,
                  });
                }}
              ></TextField>
              <DialogActions>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setopencomment(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    //console.log(comments);
                    updatecomment(comments);
                  }}
                >
                  Add
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </div>
      ) : (
        <div>
          <HubDevices
            id={props.id}
            search={props.search}
            sethub_d={sethub_d}
            detail={props.devicedetail}
            hubsid={props.hubsid}
            sethub_id={props.sethub_id}
          />
        </div>
      )}
      <Dialog
        open={hubTrail.value}
        onClose={() => {
          sethubTrail({
            id: "",
            value: false,
          });
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <CloseIcon
            sx={crossHubAction}
            onClick={() => {
              sethubTrail({
                id: "",
                value: false,
              });
            }}
          />
        </div>
        <HubHistoryTrail hub_id={hubTrail} />
      </Dialog>
    </div>
  );
}
